// extracted by mini-css-extract-plugin
export default {"logo_normal":"logo_normal__3AxSB","logo_fun":"logo_fun__3JzIN"};